import { ActionType, SiteRole, UserInfo } from '../../types';

export const UserSettingsActions = {
    loadUserSettingsStarted: () =>
        ({
            type: 'UserSettings/Load/Started',
        } as const),

    loadUserSettingsSucceeded: (status: number, data: UserInfo) =>
        ({
            type: 'UserSettings/Load/Succeeded',
            payload: { data },
        } as const),

    loadUserSettingsFailed: () =>
        ({
            type: 'UserSettings/Load/Failed',
        } as const),

    changePasswordStarted: () =>
        ({
            type: 'UserSettings/ChangePassword/Started',
        } as const),

    changePasswordSucceeded: () =>
        ({
            type: 'UserSettings/ChangePassword/Succeeded',
        } as const),

    changePasswordFailed: () =>
        ({
            type: 'UserSettings/ChangePassword/Failed',
        } as const),

    resetChangePasswordSettings: () =>
        ({
            type: 'UserSettings/ChangePassword/Reset',
        } as const),

    updateEmailUserDataStarted: () =>
        ({
            type: 'UserSettings/email/Update/Started',
        } as const),
    updateSmsUserDataStarted: () =>
        ({
            type: 'UserSettings/sms/Update/Started',
        } as const),
    updateSessionUserDataStarted: () =>
        ({
            type: 'UserSettings/session/Update/Started',
        } as const),
    updateUserDataSucceeded: (notify: boolean, sms: boolean, session: boolean) =>
        ({
            type: 'UserSettings/Update/Succeeded',
            payload: { notify, sms, session },
        } as const),
    updateUserDetailsStarted: () =>
        ({
            type: 'UserSettings/userDetails/Update/Started',
        } as const),
    updateUserDetailsSucceeded: (fName: string, lName: string, phone: string, email: string) =>
        ({
            type: 'UserSettings/userDetails/Succeeded',
            payload: { fName, lName, phone, email },
        } as const),

    updateUserDataFailed: () =>
        ({
            type: 'UserSettings/Update/Failed',
        } as const),

    userSettingsProviderUnmounted: () =>
        ({
            type: 'UserSettings/Unmounted',
        } as const),

    reset: () =>
        ({
            type: 'UserSettings/Reset',
        } as const),

    updateUserRoleStarted: () =>
        ({
            type: 'UserSettings/UserRole/Update/Started',
        } as const),

    updateUserRoleSucceeded: (updatedRoleSite: SiteRole[]) =>
        ({
            type: 'UserSettings/UserRole/Update/Succeeded',
            payload: { updatedRoleSite },
        } as const),

    updateUserRoleFailed: () =>
        ({
            type: 'UserSettings/UserRole/Update/Failed',
        } as const),
    updateUserRoleUnmounted: () =>
        ({
            type: 'UserSettings/UserRole/Update/Unmounted',
        } as const),
};

export type UserSettingsActions = ActionType<typeof UserSettingsActions>;
